// extracted by mini-css-extract-plugin
module.exports = {"pointSelectorWrapper":"PointSelector_pointSelectorWrapper__35uTr"};